import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Complete quests and earn points to increase your level. Try to reach the max! ")
const _hoisted_2 = { class: "flex flex-col items-center justify-center flex-grow p-3 space-y-2" }
const _hoisted_3 = { class: "flex space-x-2 items-center" }
const _hoisted_4 = { class: "font-bold text-2xl" }
const _hoisted_5 = { class: "flex w-full items-center space-x-2" }
const _hoisted_6 = { class: "text-gray-500 dark:text-gray-300 text-lg" }
const _hoisted_7 = { class: "flex-grow bg-gray-200 dark:bg-gray-700 h-2 rounded-full relative flex overflow-hidden" }
const _hoisted_8 = { class: "text-gray-500 dark:text-gray-300 text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Star = _resolveComponent("Star")!
  const _component_DashboardCard = _resolveComponent("DashboardCard")!

  return (_openBlock(), _createBlock(_component_DashboardCard, {
    title: "Level",
    embed: "embed:level"
  }, {
    help: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Star, { class: "text-blue-500" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.accountLevel.level), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.humanize.level(_ctx.accountLevel.level)), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$filters.number.standard(_ctx.accountLevel.creditToNextLevel)), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "bg-purple-500 dark:bg-purple-400 rounded-full",
              style: _normalizeStyle(`width: ${
                (_ctx.accountLevel.creditToNextLevel /
                  _ctx.accountLevel.requiredToNextLevel) *
                100
              }%`)
            }, null, 4)
          ]),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$filters.number.standard(_ctx.accountLevel.requiredToNextLevel)), 1)
        ])
      ])
    ]),
    _: 1
  }))
}